import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createParticipationRequest = { participation: '_participation' };
var _createParticipationResponse = { participation: '_participation' };
var _deleteParticipationRequest = {};
var _deleteParticipationResponse = {};
var _getParticipationRequest = {};
var _getParticipationResponse = { participation: '_participation' };
var _participation = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _queryParticipationsRequest = {};
var _queryParticipationsResponse = { participations: '_participation' };
var _updateParticipationRequest = {
    fieldmask: 'google.protobuf.FieldMask',
    participation: '_participation',
};
var _updateParticipationResponse = { participation: '_participation' };
function resolveWixCalendarParticipationsV3ParticipationsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/calendar/v3/participations',
                destPath: '/v3/participations',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/calendar/v3/participations',
                destPath: '/v3/participations',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a participation by ID. */
export function getParticipation(payload) {
    var _a = serializer(_getParticipationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getParticipationResponse, {
        _participation: _participation,
    }).fromJSON;
    function __getParticipation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.participation',
            method: 'GET',
            methodFqn: 'wix.calendar.participations.v3.ParticipationsService.GetParticipation',
            url: resolveWixCalendarParticipationsV3ParticipationsServiceUrl({
                protoPath: '/v3/participations/{participationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getParticipation.fromReq = fromReq;
    __getParticipation.__isAmbassador = true;
    return __getParticipation;
}
/**
 * Retrieves a list of participations, given the provided filters and paging.
 *
 * Sort: by `createdDate`, default order is `DESC`.
 */
export function queryParticipations(payload) {
    var _a = serializer(_queryParticipationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryParticipationsResponse, {
        _participation: _participation,
    }).fromJSON;
    function __queryParticipations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.participation',
            method: 'POST',
            methodFqn: 'wix.calendar.participations.v3.ParticipationsService.QueryParticipations',
            url: resolveWixCalendarParticipationsV3ParticipationsServiceUrl({
                protoPath: '/v3/participations/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryParticipations.fromReq = fromReq;
    __queryParticipations.__isAmbassador = true;
    return __queryParticipations;
}
/** Creates a schedule or event participation. */
export function createParticipation(payload) {
    var _a = serializer(_createParticipationRequest, { _participation: _participation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createParticipationResponse, {
        _participation: _participation,
    }).fromJSON;
    function __createParticipation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.participation',
            method: 'POST',
            methodFqn: 'wix.calendar.participations.v3.ParticipationsService.CreateParticipation',
            url: resolveWixCalendarParticipationsV3ParticipationsServiceUrl({
                protoPath: '/v3/participations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createParticipation.fromReq = fromReq;
    __createParticipation.__isAmbassador = true;
    return __createParticipation;
}
/** Updates a participation. */
export function updateParticipation(payload) {
    var _a = serializer(_updateParticipationRequest, { _participation: _participation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateParticipationResponse, {
        _participation: _participation,
    }).fromJSON;
    function __updateParticipation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.participation',
            method: 'PATCH',
            methodFqn: 'wix.calendar.participations.v3.ParticipationsService.UpdateParticipation',
            url: resolveWixCalendarParticipationsV3ParticipationsServiceUrl({
                protoPath: '/v3/participations/{participation.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateParticipation.fromReq = fromReq;
    __updateParticipation.__isAmbassador = true;
    return __updateParticipation;
}
/** Deletes a participation. */
export function deleteParticipation(payload) {
    var _a = serializer(_deleteParticipationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteParticipationResponse, {}).fromJSON;
    function __deleteParticipation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.participation',
            method: 'DELETE',
            methodFqn: 'wix.calendar.participations.v3.ParticipationsService.DeleteParticipation',
            url: resolveWixCalendarParticipationsV3ParticipationsServiceUrl({
                protoPath: '/v3/participations/{participationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteParticipation.fromReq = fromReq;
    __deleteParticipation.__isAmbassador = true;
    return __deleteParticipation;
}
//# sourceMappingURL=http.impl.js.map